// A shared vector asset keeps the full wordmark and favicon in sync.
export default function BrandBrick({ small = false }) {
  return (
    <img
      src="/favicon.svg"
      alt="WILL FIX IT — reflective black double-beveled lettering on a steel emblem with two workers"
      data-testid={small ? "footer-brand-logo" : "nav-brand-logo"}
      width="184"
      height="83"
      className={`block h-auto shrink-0 object-contain ${small ? "w-[176px]" : "w-[160px] sm:w-[184px]"}`}
    />
  );
}